
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moving-boxes-shipping-services",
      function () {
        return require("private-next-pages/moving-boxes-shipping-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moving-boxes-shipping-services"])
      });
    }
  